var map = {
	"./sensormodels/BREEZE-v1.1": 2925,
	"./sensormodels/BREEZE-v1.1.json": 2925,
	"./sensormodels/CHICKADEE-v2.3": 8622,
	"./sensormodels/CHICKADEE-v2.3.json": 8622,
	"./sensormodels/COMFORT-VIVID-v2.2": 435,
	"./sensormodels/COMFORT-VIVID-v2.2.json": 435,
	"./sensormodels/COMFORT-VIVID-v3.1": 2592,
	"./sensormodels/COMFORT-VIVID-v3.1.json": 2592,
	"./sensormodels/COMFORT-VIVID-v4.0": 7003,
	"./sensormodels/COMFORT-VIVID-v4.0.json": 7003,
	"./sensormodels/COMFORT-VIVID-v4.2": 8928,
	"./sensormodels/COMFORT-VIVID-v4.2.json": 8928,
	"./sensormodels/COMFORT-VIVID-v4.3": 13,
	"./sensormodels/COMFORT-VIVID-v4.3.json": 13,
	"./sensormodels/Industrial-Transceiver-1wire-v1.11": 2564,
	"./sensormodels/Industrial-Transceiver-1wire-v1.11.json": 2564,
	"./sensormodels/Industrial-Transceiver-v2.1": 9894,
	"./sensormodels/Industrial-Transceiver-v2.1.json": 9894,
	"./sensormodels/KIWI-ALL-PORT-10-v2.0": 6377,
	"./sensormodels/KIWI-ALL-PORT-10-v2.0.json": 6377,
	"./sensormodels/KIWI-CLOVER-v2.0": 629,
	"./sensormodels/KIWI-CLOVER-v2.0.json": 629,
	"./sensormodels/KIWI-v2.0": 7891,
	"./sensormodels/KIWI-v2.0.json": 7891,
	"./sensormodels/MEMO-(demo)": 9002,
	"./sensormodels/MEMO-(demo).json": 9002,
	"./sensormodels/ORCA-v0.14": 8971,
	"./sensormodels/ORCA-v0.14.json": 8971,
	"./sensormodels/ORCA-v1.0": 2598,
	"./sensormodels/ORCA-v1.0.json": 2598,
	"./sensormodels/SEAL-v1": 5141,
	"./sensormodels/SEAL-v1.json": 5141,
	"./sensormodels/SPARROW-PELICAN-v2.8": 561,
	"./sensormodels/SPARROW-PELICAN-v2.8.json": 561,
	"./sensormodels/SPARROW-PELICAN-v3.1": 3252,
	"./sensormodels/SPARROW-PELICAN-v3.1.json": 3252,
	"./sensormodels/STORK-v2.0": 7320,
	"./sensormodels/STORK-v2.0.json": 7320,
	"./sensormodels/STORK-v2.1": 2158,
	"./sensormodels/STORK-v2.1.json": 2158,
	"./sensormodels/STORK-v2.2": 4024,
	"./sensormodels/STORK-v2.2.json": 4024,
	"./sensormodels/TUNDRA-v2.1": 5176,
	"./sensormodels/TUNDRA-v2.1.json": 5176,
	"./sensormodels/eBeat-v1.0": 3566,
	"./sensormodels/eBeat-v1.0.json": 3566,
	"./sensormodels/eBeat-v1.x": 1843,
	"./sensormodels/eBeat-v1.x.json": 1843,
	"./sensormodels/eDoctor-v0.15": 5451,
	"./sensormodels/eDoctor-v0.15.json": 5451,
	"./sensormodels/eDoctor-v1": 575,
	"./sensormodels/eDoctor-v1.2": 9230,
	"./sensormodels/eDoctor-v1.2.json": 9230,
	"./sensormodels/eDoctor-v1.json": 575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;